import { render } from "./TATVerticalBarChart.vue?vue&type=template&id=60462dd6"
import script from "./TATVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./TATVerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__